let scrollPosition = 0;
let pageScrolledByBodyLock = false;

export default {
    enable() {
        const { clientWidth } = document.getElementsByTagName('body')[0];
        const header = document.getElementsByTagName('header')[0];
        const plpPaginator = document.getElementsByClassName('plp-paginator')[0];

        pageScrolledByBodyLock = true;
        scrollPosition = window.pageYOffset;

        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollPosition}px`;
        document.body.style.width = `${clientWidth}px`;

        header.style.width = `${clientWidth}px`;

        if (plpPaginator) {
            plpPaginator.style.width = `${clientWidth}px`;
        }
    },
    disable() {
        const header = document.getElementsByTagName('header')[0];
        const plpPaginator = document.getElementsByClassName('plp-paginator')[0];
        pageScrolledByBodyLock = true;

        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('position');
        document.body.style.removeProperty('top');
        document.body.style.removeProperty('width');

        window.scrollTo(0, scrollPosition);
        scrollPosition = 0;

        header.style.removeProperty('width');

        if (plpPaginator) {
            plpPaginator.style.removeProperty('width');
        }
    },
    get isPageScroledByBodyLock() {
        // This property should be read only once
        // and after reading of it value should be seted false
        const result = pageScrolledByBodyLock;
        pageScrolledByBodyLock = false;
        return result;
    },
};
